import React from 'react';
import Skeleton from '../Skeleton/Skeleton';
import './Card.scss';

const Loading = ({ hasError }) => {
    return (
        <div>
            <div className="card">
                <a className="icon">
                    <span className="flex flex-column">
                        <Skeleton circle={true} height={56} width={56} hasError={hasError} />
                        <div
                            className="flex flex-column justify-space-around "
                            style={{
                                height: '25px'
                            }}>
                            <Skeleton width={25} hasError={hasError} />
                        </div>
                    </span>
                </a>
                <a
                    className="flex flex-column center-aligned justify-space-around "
                    style={{
                        height: '60px'
                    }}>
                    <Skeleton width={150} height={30} hasError={hasError} />
                </a>
                <div className="info">
                    <label>Policy effective</label>

                    <div
                        style={{
                            height: '30px'
                        }}>
                        <Skeleton width={90} hasError={hasError} />
                    </div>
                </div>
                <div className="info">
                    <label>Safeco premium</label>
                    <div className="green">
                        <Skeleton width={90} hasError={hasError} />
                    </div>
                </div>
                <div className="info">
                    <label>Change</label>
                    <div>
                        <Skeleton width={90} hasError={hasError} />
                    </div>
                </div>
                <div className="info">
                    <label>Previous carrier - last term premium</label>
                    <div>
                        <Skeleton width={90} hasError={hasError} />
                    </div>
                </div>

                <div className="info">
                    <label>
                        <div>
                            <Skeleton width={80} hasError={hasError} />
                        </div>
                    </label>

                    <div>
                        <div>
                            <Skeleton width={90} hasError={hasError} />
                        </div>
                        <Skeleton width={90} hasError={hasError} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Card/Loading.jsx